//custom code to prevent infinitie purchases on backorders 
document.addEventListener('DOMContentLoaded', function() {
  
  // Vertalingen
  const translations = {
    nl: {
      title: '⚠️ Let op: Backorder',
      intro: 'U bestelt meer dan de huidige voorraad. Een deel van uw bestelling wordt als backorder verwerkt.',
      currentStock: 'Huidige voorraad:',
      backorderAvailable: 'Backorder beschikbaar:',
      youOrder: 'U bestelt:',
      ofWhichBackorder: 'Waarvan backorder:',
      leadtimeLabel: 'Levertijd backorder:',
      leadtimeFallback: 'Levertijd wordt later gecommuniceerd',
      splitShipment: '💡 Tip: Bij bestellingen boven €150 exl btw versturen wij wat we op voorraad hebben direct, de rest volgt zodra alles beschikbaar is.',
      pieces: 'stuks',
      cancel: 'Annuleren',
      confirmCart: 'Doorgaan met bestellen',
      confirmCheckout: 'Doorgaan naar checkout',
      maxAvailable: 'Maximaal {max} stuks beschikbaar (voorraad: {stock}, backorder limiet: {backorder})'
    },
    de: {
      title: '⚠️ Achtung: Nachbestellung',
      intro: 'Sie bestellen mehr als den aktuellen Lagerbestand. Ein Teil Ihrer Bestellung wird als Nachbestellung bearbeitet.',
      currentStock: 'Aktueller Lagerbestand:',
      backorderAvailable: 'Nachbestellung verfügbar:',
      youOrder: 'Sie bestellen:',
      ofWhichBackorder: 'Davon Nachbestellung:',
      leadtimeLabel: 'Lieferzeit Nachbestellung:',
      leadtimeFallback: 'Lieferzeit wird später mitgeteilt',
      splitShipment: '💡 Tipp: Bei Bestellungen über 200 € exkl. MwSt. versenden wir die vorrätigen Artikel sofort, der Rest folgt, sobald alles verfügbar ist.',
      pieces: 'Stück',
      cancel: 'Abbrechen',
      confirmCart: 'Weiter bestellen',
      confirmCheckout: 'Zur Kasse gehen',
      maxAvailable: 'Maximal {max} Stück verfügbar (Lagerbestand: {stock}, Nachbestellung Limit: {backorder})'
    },
    fr: {
      title: '⚠️ Attention: Commande en souffrance',
      intro: 'Vous commandez plus que le stock actuel. Une partie de votre commande sera traitée comme commande en souffrance.',
      currentStock: 'Stock actuel:',
      backorderAvailable: 'Commande en souffrance disponible:',
      youOrder: 'Vous commandez:',
      ofWhichBackorder: 'Dont commande en souffrance:',
      leadtimeLabel: 'Délai de livraison commande en souffrance:',
      leadtimeFallback: 'Le délai de livraison sera communiqué ultérieurement',
      splitShipment: '💡 Astuce: Pour les commandes supérieures à 200 € hors TVA, nous expédions immédiatement les articles en stock, le reste suit dès que tout est disponible.',
      pieces: 'pièces',
      cancel: 'Annuler',
      confirmCart: 'Continuer la commande',
      confirmCheckout: 'Passer à la caisse',
      maxAvailable: 'Maximum {max} pièces disponibles (stock: {stock}, limite commande en souffrance: {backorder})'
    },
    en: {
      title: '⚠️ Notice: Backorder',
      intro: 'You are ordering more than the current stock. Part of your order will be processed as a backorder.',
      currentStock: 'Current stock:',
      backorderAvailable: 'Backorder available:',
      youOrder: 'You order:',
      ofWhichBackorder: 'Of which backorder:',
      leadtimeLabel: 'Backorder lead time:',
      leadtimeFallback: 'Lead time will be communicated later',
      splitShipment: '💡 Tip: For orders over €200 excluding VAT, we will ship what we have in stock immediately, and the rest will follow as soon as everything is available.',
      pieces: 'pieces',
      cancel: 'Cancel',
      confirmCart: 'Continue ordering',
      confirmCheckout: 'Proceed to checkout',
      maxAvailable: 'Maximum {max} pieces available (stock: {stock}, backorder limit: {backorder})'
    }
  };
  
  const config = window.productBackorderConfig;
  
if (!config) {
  return;
}

if (!config.continueSellingEnabled) {
  return;
}

const quantityInput = document.querySelector('input[name="quantity"]');
const addToCartButton = document.querySelector('[name="add"]');

if (!quantityInput || !addToCartButton) {
  return;
}
  
  let isProcessingBackorder = false;
  
  function validateQuantity(qty) {
    qty = parseInt(qty) || 1;
    
    if (qty > config.maxSellable) {
      showError();
      quantityInput.value = config.maxSellable;
      return false;
    }
    
    clearError();
    return true;
  }
  
  function showError() {
    const locale = config.locale || 'nl';
    const t = translations[locale] || translations.nl;
    
    const errorMessage = t.maxAvailable
      .replace('{max}', config.maxSellable)
      .replace('{stock}', config.currentInventory)
      .replace('{backorder}', config.backorderQty);
    
    let errorDiv = document.querySelector('.quantity-error');
    if (!errorDiv) {
      errorDiv = document.createElement('div');
      errorDiv.className = 'quantity-error';
      
      const addButton = document.querySelector('.product-info__add-button');
      const addToCartContainer = document.querySelector('.product-info__add-to-cart');
      
      if (addButton) {
        addButton.parentNode.insertBefore(errorDiv, addButton.nextSibling);
      } else if (addToCartContainer) {
        addToCartContainer.parentNode.insertBefore(errorDiv, addToCartContainer.nextSibling);
      } else {
        const qtyParent = quantityInput.closest('.product-info__add-to-cart') || quantityInput.parentNode;
        qtyParent.appendChild(errorDiv);
      }
    }
    errorDiv.textContent = errorMessage;
    errorDiv.style.display = 'block';
  }
  
  function clearError() {
    const errorDiv = document.querySelector('.quantity-error');
    if (errorDiv) {
      errorDiv.style.display = 'none';
    }
  }
  
  function showLeadtimePopup(qty, targetButton) {
  const backorderQty = qty - config.currentInventory;
  const locale = config.locale || 'nl';
  const t = translations[locale] || translations.nl;
  
  const existingPopup = document.querySelector('.backorder-popup');
  if (existingPopup) {
    existingPopup.remove();
  }
  
  const leadtimeText = config.leadtimeMessage || t.leadtimeFallback;
  
  const popup = document.createElement('div');
  popup.className = 'backorder-popup';
  
  const overlay = document.createElement('div');
  overlay.className = 'backorder-popup__overlay';
  
  const content = document.createElement('div');
  content.className = 'backorder-popup__content';
  
  const title = document.createElement('h3');
  title.textContent = t.title;
  
  const intro = document.createElement('p');
  intro.textContent = t.intro;
  
  const infoBox = document.createElement('div');
  infoBox.className = 'backorder-popup__info';
  infoBox.innerHTML = `
    <div class="backorder-popup__info-item">
      <span class="backorder-popup__info-label">${t.currentStock}</span>
      <span class="backorder-popup__info-value">${config.currentInventory} ${t.pieces}</span>
    </div>
    <div class="backorder-popup__info-item">
      <span class="backorder-popup__info-label">${t.backorderAvailable}</span>
      <span class="backorder-popup__info-value">${config.backorderQty} ${t.pieces}</span>
    </div>
    <div class="backorder-popup__info-item">
      <span class="backorder-popup__info-label">${t.youOrder}</span>
      <span class="backorder-popup__info-value">${qty} ${t.pieces}</span>
    </div>
    <div class="backorder-popup__info-item">
      <span class="backorder-popup__info-label">${t.ofWhichBackorder}</span>
      <span class="backorder-popup__info-value" style="color: #d97706;">${backorderQty} ${t.pieces}</span>
    </div>
  `;
  
  const leadtimeBox = document.createElement('div');
  leadtimeBox.className = 'backorder-popup__leadtime';
  const leadtimeLabel = document.createElement('strong');
  leadtimeLabel.textContent = t.leadtimeLabel + ' ';
  const leadtimeValue = document.createTextNode(leadtimeText);
  leadtimeBox.appendChild(leadtimeLabel);
  leadtimeBox.appendChild(leadtimeValue);
  
  const splitShipmentBox = document.createElement('div');
  splitShipmentBox.className = 'backorder-popup__split-shipment';
  splitShipmentBox.textContent = t.splitShipment;
  
  const buttonsDiv = document.createElement('div');
  buttonsDiv.className = 'backorder-popup__buttons';
  
  const cancelBtn = document.createElement('button');
  cancelBtn.type = 'button';
  cancelBtn.className = 'backorder-popup__cancel';
  cancelBtn.textContent = t.cancel;
  
  const confirmBtn = document.createElement('button');
  confirmBtn.type = 'button';
  confirmBtn.className = 'backorder-popup__confirm';
  confirmBtn.textContent = t.confirmCart;
  
  buttonsDiv.appendChild(cancelBtn);
  buttonsDiv.appendChild(confirmBtn);
  
  content.appendChild(title);
  content.appendChild(intro);
  content.appendChild(infoBox);
  content.appendChild(leadtimeBox);
  content.appendChild(splitShipmentBox);
  content.appendChild(buttonsDiv);
  
  popup.appendChild(overlay);
  popup.appendChild(content);
  
  document.body.appendChild(popup);
  document.body.style.overflow = 'hidden';
  
  cancelBtn.addEventListener('click', function() {
    popup.remove();
    document.body.style.overflow = '';
  });
  
  overlay.addEventListener('click', function() {
    popup.remove();
    document.body.style.overflow = '';
  });
  
  confirmBtn.addEventListener('click', function() {
    popup.remove();
    document.body.style.overflow = '';
    
    const form = addToCartButton.closest('form');
    if (form) {
      HTMLFormElement.prototype.submit.call(form);
    }
  });
}

function showLeadtimePopupForPayment(qty, paymentButton) {
  const backorderQty = qty - config.currentInventory;
  const locale = config.locale || 'nl';
  const t = translations[locale] || translations.nl;
  
  const existingPopup = document.querySelector('.backorder-popup');
  if (existingPopup) {
    existingPopup.remove();
  }
  
  const leadtimeText = config.leadtimeMessage || t.leadtimeFallback;
  
  const popup = document.createElement('div');
  popup.className = 'backorder-popup';
  
  const overlay = document.createElement('div');
  overlay.className = 'backorder-popup__overlay';
  
  const content = document.createElement('div');
  content.className = 'backorder-popup__content';
  
  const title = document.createElement('h3');
  title.textContent = t.title;
  
  const intro = document.createElement('p');
  intro.textContent = t.intro;
  
  const infoBox = document.createElement('div');
  infoBox.className = 'backorder-popup__info';
  infoBox.innerHTML = `
    <div class="backorder-popup__info-item">
      <span class="backorder-popup__info-label">${t.currentStock}</span>
      <span class="backorder-popup__info-value">${config.currentInventory} ${t.pieces}</span>
    </div>
    <div class="backorder-popup__info-item">
      <span class="backorder-popup__info-label">${t.backorderAvailable}</span>
      <span class="backorder-popup__info-value">${config.backorderQty} ${t.pieces}</span>
    </div>
    <div class="backorder-popup__info-item">
      <span class="backorder-popup__info-label">${t.youOrder}</span>
      <span class="backorder-popup__info-value">${qty} ${t.pieces}</span>
    </div>
    <div class="backorder-popup__info-item">
      <span class="backorder-popup__info-label">${t.ofWhichBackorder}</span>
      <span class="backorder-popup__info-value" style="color: #d97706;">${backorderQty} ${t.pieces}</span>
    </div>
  `;
  
  const leadtimeBox = document.createElement('div');
  leadtimeBox.className = 'backorder-popup__leadtime';
  const leadtimeLabel = document.createElement('strong');
  leadtimeLabel.textContent = t.leadtimeLabel + ' ';
  const leadtimeValue = document.createTextNode(leadtimeText);
  leadtimeBox.appendChild(leadtimeLabel);
  leadtimeBox.appendChild(leadtimeValue);
  
  const splitShipmentBox = document.createElement('div');
  splitShipmentBox.className = 'backorder-popup__split-shipment';
  splitShipmentBox.textContent = t.splitShipment;
  
  const buttonsDiv = document.createElement('div');
  buttonsDiv.className = 'backorder-popup__buttons';
  
  const cancelBtn = document.createElement('button');
  cancelBtn.type = 'button';
  cancelBtn.className = 'backorder-popup__cancel';
  cancelBtn.textContent = t.cancel;
  
  const confirmBtn = document.createElement('button');
  confirmBtn.type = 'button';
  confirmBtn.className = 'backorder-popup__confirm';
  confirmBtn.textContent = t.confirmCheckout;
  
  buttonsDiv.appendChild(cancelBtn);
  buttonsDiv.appendChild(confirmBtn);
  
  content.appendChild(title);
  content.appendChild(intro);
  content.appendChild(infoBox);
  content.appendChild(leadtimeBox);
  content.appendChild(splitShipmentBox);
  content.appendChild(buttonsDiv);
  
  popup.appendChild(overlay);
  popup.appendChild(content);
  
  document.body.appendChild(popup);
  document.body.style.overflow = 'hidden';
  
  cancelBtn.addEventListener('click', function() {
    popup.remove();
    document.body.style.overflow = '';
  });
  
  overlay.addEventListener('click', function() {
    popup.remove();
    document.body.style.overflow = '';
  });
  
  confirmBtn.addEventListener('click', function() {
    popup.remove();
    document.body.style.overflow = '';
    
    const form = paymentButton.closest('form');
    if (form) {
      HTMLFormElement.prototype.submit.call(form);
    }
  });
}

quantityInput.addEventListener('change', function() {
  validateQuantity(this.value);
});

quantityInput.addEventListener('input', function() {
  validateQuantity(this.value);
});

function handleAddToCart(e) {
  const qty = parseInt(quantityInput.value) || 1;
  
  if (!validateQuantity(qty)) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  }
  
  if (qty > config.currentInventory) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    showLeadtimePopup(qty, e.currentTarget);
    return false;
  }
}

addToCartButton.addEventListener('click', handleAddToCart, true);

const productForm = addToCartButton.closest('form');
if (productForm) {
  productForm.addEventListener('submit', handleAddToCart, true);
}

const paymentButtons = document.querySelectorAll('.shopify-payment-button__button');
paymentButtons.forEach(function(button) {
  button.addEventListener('click', function(e) {
    const qty = parseInt(quantityInput.value) || 1;
    
    if (!validateQuantity(qty)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
    
    if (qty > config.currentInventory) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      showLeadtimePopupForPayment(qty, button);
      return false;
    }
  }, true);
});
  
  console.log('=== BACKORDER SCRIPT INITIALIZED ===');
});